<div *ngIf="serverError" class="bofa--alert has-background has-padding">
        <span> <img alt="error" src="assets/errorIcon.png"></span>
        <span>{{errorMessage}}</span>
</div>
